import * as XLSX from "xlsx";
import users from "./users";

import {
  count_keys_start_with,
  get_keys_start_with,
  multipy_keys_start_with,
  sum_breakdown,
  get_item_template,
  if_period_based_item_exist,
  total_perid_in_days,
  has_freight_quantity,
  get_freight_quantity,
  get_total,
  get_perf_freight,
  get_unsettled_total,
  sanitize_account,
} from "./voyage_account_util";

export function summary_to_excel(data, filename = "PL.xlsx") {
  console.log("Exporting to Excel:", data);
  console.log("USERS:", users);

  let records = [];
  data.forEach((item) => {
    let record_head = {
      ID: item.id,
      MV: item.mv,
      CHATERER: item.charterer,
      LEG: item.leg,
      CHARTER_TYPE: item.charter_type,
      VOYAGE_YEAR: item.voyage_year,
      LAYDAY: item.laycan[0],
      CANDAY: item.laycan[1],
      LOADPORT: item.load_port,
      DISCPORT: item.disc_port,
    };
    if (!has_freight_quantity(item)) {
      item.bl.forEach((b, b_pos) => {
        let record = {
          ...record_head,
        };
        record.BL_DATE = b.date;
        record.BL_CARGO = b.cargo;
        record.BL_QUANTITY = b.quantity;
        record.CP_FREIGHT = "";
        record.PERFORMANCE_FREIGHT = "";
        record.VOYAGE_PROFIT_LOSS = "";
        record.CREATOR = users.find((user) => user.id == item.creator).name;
        if (b_pos == 0) {
          record.VOYAGE_PROFIT_LOSS =
            get_total(item, "debit") - get_total(item, "credit");
        }
        records.push(record);
      });
    } else {
      let sub_ac = item.accounts.find(
        (ac) => ac.account_name == "Charterer"
      ).sub_accounts;
      sub_ac.forEach((sub) => {
        if (sub.hasOwnProperty("is_freight")) {
          sub.breakdown
            .filter((brd) => brd.calc_type == "two")
            .forEach((bd, bd_pos) => {
              if (bd.calc_type == "two") {
                let record = {
                  ...record_head,
                };
                record.BL_DATE = bd.bl_date;
                record.BL_CARGO = bd.item_name;
                record.BL_QUANTITY = bd.value_TONS;
                record.CP_FREIGHT = bd.value_FREIGHT;
                record.CREATOR = users.find(
                  (user) => user.id == item.creator
                ).name;
                record.PERFORMANCE_FREIGHT = get_perf_freight(item, sub)[
                  bd_pos
                ];
                record.VOYAGE_PROFIT_LOSS = "";
                if (bd_pos == 0) {
                  record.VOYAGE_PROFIT_LOSS =
                    get_total(item, "debit") - get_total(item, "credit");
                }
                records.push(record);
              }
            });
        }
      });
    }
  });

  const ws = XLSX.utils.json_to_sheet(records);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, filename);
}
